import React from 'react';
import { Box, Move, Stagger } from '@razorpay/blade/components';
import { useFormWithProvider } from 'forms';

import { BaseDaysAndHours } from './components/BaseDaysAndHours';
import { OvertimeSection } from './components/OvertimeSection';
import type { AttendanceSettingsFormState } from 'components/Settings/AttendanceAndLeavesSettings/types';

export const PayRulesTab = () => {
  const { formData, setFieldValue } = useFormWithProvider<AttendanceSettingsFormState>();

  const isBaseHoursSaved = formData.baseHours != null;

  return (
    <Stagger
      motionTriggers={['mount']}
      delay="2xquick"
      display="flex"
      flexDirection="column"
      gap="spacing.6">
      <Move>
        <Box>
          <BaseDaysAndHours
            baseHours={formData.baseHours}
            isBaseHoursSaved={isBaseHoursSaved}
            onBaseHoursChange={(value) => setFieldValue('baseHours', value)}
            calculateLopOnWorkingDays={!!formData.calculateLopOnWorkingDays}
            onCalculateLopOnWorkingDaysChange={(value) =>
              setFieldValue('calculateLopOnWorkingDays', value)
            }
          />
        </Box>
      </Move>
      <Move>
        <Box>{!!formData.baseHoursInDb && <OvertimeSection />}</Box>
      </Move>
    </Stagger>
  );
};
